export default __webpack_public_path__ + "static/media/image-2.7ba0f764.jpg";